<template>
<div class="subpage-nav">
  <container>
    <div class="subpage-nav__list">
      <div class="subpage-nav__item" v-for="link in links" :key="link.id" :class="{'active' : isActive}" @click="select">
        <div v-on:click="selectCategory(link)" class="subpage-nav__link">
      <span class="btn-txt">
        {{ link.title }}
      </span>
        </div>
      </div>
    </div>
  </container>
</div>
</template>

<script>
import { SET_BLOG_CATEGORY_TITLE, SET_BLOG_CATEGORY_SLUG } from '@/store/mutations.type'
export default {
  name: 'SubpageNav2',
  props: {
    links: Array
  },
  data () {
    return {
      isActive: false
    }
  },
  methods: {
    select () {
      this.isActive = true
    },
    selectCategory(opt) {
      this.$store.commit(SET_BLOG_CATEGORY_TITLE, opt.title )
      this.$store.commit(SET_BLOG_CATEGORY_SLUG, opt.value )
      window.localStorage.setItem('blogCategory', opt.value)
      this.$router.push('/blog/kategori/' + opt.value )
    },    
  }
}
</script>

<style scoped lang="scss">
@import "../assets/scss/components/subpage-nav";
</style>
